module.exports = __webpack_public_path__ + "img/fuel_tank_18l.6a3e6a3b.png";